import React, { Component } from "react";
import { connect } from "react-redux";

import FilterSelectedList from "../components/General/FilterSelectedList";
//import imageicon from "./ico-image.svg";

/* Imports from Material MUI */
import { withStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";

import Swal from "sweetalert2";
import {
  //Button,
  //FormControlLabel,
  IconButton,
  Link,
  //Typography,
} from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import { DateTime } from "mssql";

const styles = (theme) => ({
  root: {
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "left",
    //border: "1px solid red",
    margin: "1rem",
    width: "95%",
    height: "85vh",
    fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri`,
  },
  tableRoot: {
    overFlow: "auto",
    height: "100%",
    maxHeight: "80vh",
    display: "flex",
  },
  table: {
    flexGrow: 1,
  },
  tableHeader: {
    //textTransform: "uppercase",
    fontWeight: 900,
    fontSize: "14px",
    borderright: "1px solid #fff",
    color: "white",
    backgroundColor: "#113A7D", //"#1451B5", //"#2980B9",
    headerAlign: "center",
  },
  dataGrid: {
    height: "100%",
    width: "100%",
  },
  cellValue: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageSize: 10,
      page: 0,
      sortModel: [
        {
          field: "FrontLTV",
          sort: "asc",
        },
      ],
    };
  }

  customToolbar = () => {
    return (
      <GridToolbarContainer className={gridClasses.toolbarContainer}>
        <GridToolbarExport
          csvOptions={{ allColumns: true }}
          //fields:["VIN","Body_Style","Make","Model","Vehicle_model_year","Mileage","AskingPrice","Vehicle_Value","AmountFinanced","FrontLTV","PaymentEst","Dealername","Dealer_State","StateTax","Doc_Fee","DMVFeeEst","ShippingFees","ImgURLS","URL_Link" ]
          printOptions={{ disableToolbarButton: true }}
          style={{ color: "#1451B5" }}
        />
      </GridToolbarContainer>
    );
  };

  componentDidMount() {
    if (
      this.props.user.name.trim() === "" ||
      this.props.user.email.trim() === ""
    ) {
      this.props.history.push("/login");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.filterData.filterData !== this.props.filterData.filterData) {
      this.setState({
        sortModel: [
          {
            field: "FrontLTV",
            sort: "asc",
          },
        ],
      });
    }
  }

  navigateToHistory = () => {
    this.props.history.push("/historyView");
  };

  render() {
    const { classes } = this.props;
    const filterData = this.props.filterData.filterData;
    const isLoading = this.props.filterData.isLoading;

    //console.log("data count of datagrid", filterData.length);

    //DataGrid Columns Format and Column Names
    const currencyFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    });

    const NumberFormat = {
      type: "number",
      valueFormatter: ({ value }) =>
        new Intl.NumberFormat().format(Number(value)),
    };

    const usdPrice = {
      type: "number",            
      valueFormatter: ({ value }) => currencyFormatter.format(Number(value)),
    };

    const perValue = {
      type: "number",
      valueFormatter: (params) => {
        const valueFormatted = Math.round(
          Number(params.value * 100)
        ).toLocaleString();
        return `${valueFormatted}%`;
      },
    };

    const headerColStyle = {
      headerClassName: classes.tableHeader,
      headerAlign: "center",
      //sortable: false,
    };

    //Open Image attached to Vin Data
    const onVINClick = (row) => {
      //console.log("Image Url", imageURL);
      Swal.fire({
        width:600,
        imageUrl: row.ImageURLS,
        imageHeight: 400,
        imageWidth: 800,
        //html: `<small>Vin: ${row.VIN}<br/>Make: ${row.Make}<br/>Model: ${row.Model}<br/>Style: ${row.Body_Style}</small>`,
        html: `<table width="70%" style="font-size:12px">
        <tr width="100%"><td style="font-weight:bold;padding:0px;text-align: left;width:20%;">VIN:</td><td style="padding:0px;text-align: left;width:80%;">${row.VIN}</td></tr>
        <tr width="100%"><td style="font-weight:bold;padding:0px;text-align: left;width:20%;">Make:</td><td style="padding:0px;text-align: left;width:80%;">${row.Make}</td></tr>
        <tr width="100%"><td style="font-weight:bold;padding:0px;text-align: left;width:20%;">Model:</td><td style="padding:0px;text-align: left;width:80%;">${row.Model}</td></tr>        
        <tr width="100%"><td style="font-weight:bold;padding:0px;text-align: left;width:20%;">Style:</td><td style="padding:0px;text-align: left;width:80%;">${row.Body_Style}</td></tr>        
        </table>`,
        imageAlt: "VIN Image",
        confirmButtonColor: "#1451B5",
        //footer: `<a href=${row.URL_Link} target="_blank" rel="noopener noreferrer">Driway.com</a>`,
      });
    };

    // const onCopy = (value) => {
    //   // const el = document.createElement("input");
    //   // el.value = value;
    //   // document.body.appendChild(el);
    //   // el.select();
    //   // document.execCommand("copy");
    //   // document.body.removeChild(el);
    //   //console.log("Copy");
    //   navigator.clipboard.writeText(value).catch((e) => console.error(e));
    // };

    const columns = [
      {
        field: "VIN",
        headerName: "VIN",
        ...headerColStyle,
        width: 200,
        renderCell: (params) =>
          params.row.URL_Link !== "" ? (
            params.value && params.value.length > 50 ? (
              <Tooltip title={params.value} followCursor>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Link
                    href={params.row.URL_Link}
                    //color="primary"
                    target="_blank"
                    el="noopener"
                    underline="hover"
                    style={{ color: "#1451B5" }}
                  >
                    {params.value}
                  </Link>
                  {params.row.ImageURLS !== "" && (
                    <IconButton
                      color="primary"
                      component="span"
                      onClick={() => onVINClick(params.row)}
                    >               
                      {/* <img src={imageicon}   />                       */}
                      <ImageIcon style={{ color: "#1451B5" }} />
                    </IconButton>
                  )}
                </div>
              </Tooltip>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Link
                  href={params.row.URL_Link}
                  color="primary"
                  target="_blank"
                  el="noopener"
                  underline="hover"
                  style={{ color: "#1451B5" }}
                >
                  {params.value}
                </Link>
                {params.row.ImageURLS !== "" && (
                  <IconButton
                    style={{ marginLeft: "1px" }}
                    color="primary"
                    component="span"
                    onClick={() => onVINClick(params.row)}
                  >
                     {/* <img src={imageicon}   />  */}
                    <ImageIcon style={{ color: "#1451B5" }} />
                  </IconButton>
                )}
              </div>
            )
          ) : params.value && params.value.length > 50 ? (
            <Tooltip title={params.value} followCursor>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div className="cellValue">{params.value}</div>
                {params.row.ImageURLS !== "" && (
                  <IconButton
                    color="primary"
                    component="span"
                    onClick={() => onVINClick(params.row)}
                  >
                     {/* <img src={imageicon}  />  */}
                    <ImageIcon style={{ color: "#1451B5" }} />
                  </IconButton>
                )}
              </div>
            </Tooltip>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div className="cellValue">{params.value}</div>
              {params.row.ImageURLS !== "" && (
                <IconButton
                  color="primary"
                  component="span"
                  onClick={() => onVINClick(params.row)}
                >
                   {/* <img src={imageicon}   />  */}
                  <ImageIcon style={{ color: "#1451B5" }} />
                </IconButton>
              )}
            </div>
          ),
        // <Link
        //   component="button"
        //   color="primary"
        //   onClick={() => onVINClick(params.row)}
        // >
        //   {" "}
        //   {params.value}
        // </Link>
        //     <FormControlLabel label={
        //       <Typography sx={{ fontSize: "12px",color: "#116BBD",padding:"0px" }}>
        //         {params.value}
        //       </Typography>
        //       }
        //      //onMouseDown={() => onCopy(params.value)}
        //      labelPlacement="start"
        //      control={
        //       // <Button variant="text" size="small"
        //       //   style={{padding:"0px"}}
        //       //   onClick={() => onVINClick(params.row)}>
        //       // </Button>
        //       <Link href={params.row.URL_Link} target="_blank" el="noopener" underline="hover">
        //       {params.row.URL_Link}
        //       </Link>
        //     }>
        //     </FormControlLabel>
        //   )
        // ) : params.value && params.value.length > 50 ? (
        //   <Tooltip title={params.value} followCursor>
        //     <div className="cellValue">{params.value}</div>
        //   </Tooltip>
        // ) : (
        //   <div className="cellValue">{params.value}</div>
        // ),
      },
      {
        field: "Body_Style",
        headerName: "Style",
        ...headerColStyle,
        width: 250,
        renderCell: (params) =>
          params.value && params.value.length > 20 ? (
            <Tooltip title={params.value} followCursor>
              <div className="cellValue">{params.value}</div>
            </Tooltip>
          ) : (
            <div className="cellValue">{params.value}</div>
          ),
      },
      {
        field: "Make",
        headerName: "Make",
        ...headerColStyle,
        width: 150,
        renderCell: (params) =>
          params.value && params.value.length > 20 ? (
            <Tooltip title={params.value} followCursor>
              <div className="cellValue">{params.value}</div>
            </Tooltip>
          ) : (
            <div className="cellValue">{params.value}</div>
          ),
      },
      {
        field: "Model",
        headerName: "Model",
        ...headerColStyle,
        width: 150,
        renderCell: (params) =>
          params.value && params.value.length > 20 ? (
            <Tooltip title={params.value} followCursor>
              <div className="cellValue">{params.value}</div>
            </Tooltip>
          ) : (
            <div className="cellValue">{params.value}</div>
          ),
      },
      {
        field: "Vehicle_model_year",
        headerName: "Year",
        ...headerColStyle,
        width: 100,
        renderCell: (params) =>
          params.value && params.value.length > 10 ? (
            <Tooltip title={params.value} followCursor>
              <div className="cellValue">{params.value}</div>
            </Tooltip>
          ) : (
            <div className="cellValue">{params.value}</div>
          ),
      },
      {
        field: "Mileage",
        headerName: "Mileage",
        ...headerColStyle,
        width: 100,
        ...NumberFormat,
      },
      {
        field: "AskingPrice",
        headerName: "Sale Price",
        ...headerColStyle,
        width: 100,
        ...usdPrice,
      },
      {
        field: "Vehicle_Value",
        headerName: "Book Value (Black Book)",
        ...headerColStyle,
        width: 200,
        ...usdPrice,
      },
      {
        field: "AmountFinanced",
        headerName: "Amt Finance",
        ...headerColStyle,
        width: 150,
        ...usdPrice,
      },
      {
        field: "FrontLTV",
        headerName: "Front LTV",
        ...headerColStyle,
        width: 150,
        ...perValue,
      },
      {
        field: "PaymentEst",
        headerName: "Payment Est",
        ...headerColStyle,
        width: 150,
        ...usdPrice,
      },
      {
        field: "Dealername",
        headerName: "Dealer Name",
        ...headerColStyle,
        width: 300,
        renderCell: (params) =>
          params.value && params.value.length > 10 ? (
            <Tooltip title={params.value} followCursor>
              <div className="cellValue">{params.value}</div>
            </Tooltip>
          ) : (
            <div className="cellValue">{params.value}</div>
          ),
      },
      {
        field: "Dealer_State",
        headerName: "Dealer State",
        ...headerColStyle,
        width: 150,
        renderCell: (params) =>
          params.value && params.value.length > 10 ? (
            <Tooltip title={params.value} followCursor>
              <div className="cellValue">{params.value}</div>
            </Tooltip>
          ) : (
            <div className="cellValue">{params.value}</div>
          ),
      },
      {
        field: "StateTax",
        headerName: "State Tax",
        ...headerColStyle,
        width: 100,
        ...usdPrice,
      },
      {
        field: "Doc_Fee",
        headerName: "Doc Fees",
        ...headerColStyle,
        width: 100,
        ...usdPrice,
      },
      {
        field: "DMVFeeEst",
        headerName: "DMV Fees",
        ...headerColStyle,
        width: 100,
        ...usdPrice,
      },
      {
        field: "ShippingFees",
        headerName: "Shipping Fees",
        ...headerColStyle,
        width: 150,
        ...usdPrice,
      },
    ];

    return (
      <div className={classes.root}>
        {/* selected Filters List */}
        <div
          style={{
            width: "100%",
            height: "10vh",
            display: "flex",
            overflow: "none",
            marginTop: "2px",
            marginBottom: "2px",
          }}
        >
          <FilterSelectedList />

          {/* <Divider /> */}
          {/* <div
            style={{
              display: "flex",
              marginTop: "5px",
              marginBottom: "5px",
              borderLeft: "1px solid #ccc",
              alignItems: "center",
              justifyContent: "center",
              width: "5%",
            }}
          >
            <IconButton
              color="primary"
              aria-label="History"
              onClick={this.navigateToHistory}
            >
              <HistoryIcon
                color="primary"
                fontSize="large"
                titleAccess="History"
              />
            </IconButton>
          </div> */}
        </div>
        <div className={classes.tableRoot} style={{ overflow: "none" }}>
          <div className={classes.table}>
            {/* Row height of 52 pixels.  */}
            <DataGrid
              style={{ fontSize: "12px",fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri`, }}
              getRowId={(row) => row.VIN + DateTime()}
              rows={filterData}
              columns={columns}
              disableSelectionOnClick={true}
              isCellEditable={false}
              loading={isLoading}
              rowHeight={45}
              showCellRightBorder={true}
              showColumnRightBorder={true}
              page={this.state.page}
              pageSize={this.state.pageSize}
              onPageSizeChange={(newPageSize) =>
                this.setState({ pageSize: newPageSize })
              }
              onPageChange={(newPage) => this.setState({ page: newPage })}
              rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
              pagination={true}
              sortModel={this.state.sortModel}
              onSortModelChange={(model) => this.setState({ sortModel: model })}
              components={{
                Toolbar: filterData.length > 0 && this.customToolbar,
              }}
              className={classes.dataGrid}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mstp = (state) => {
  return {
    user: state.user,
    filterData: state.filterData,
  };
};

export default connect(mstp, {})(withStyles(styles, { withTheme: true })(Home));
